import { useTranslation } from "react-i18next";
import { Badge } from "../Badge/Badge";

interface StatusBadgeProps {
	status: string;
	type?:
		| "lead"
		| "opportunity"
		| "offer"
		| "activity"
		| "order"
		| "contract"
		| "stockItem"
		| "generic";
}

const leadMap: Record<string, string> = {
	new: "default",
	converted: "success",
};

const oppMap: Record<string, string> = {
	open: "primary",
	won: "success",
	lost: "danger",
	abandoned: "muted",
};

const offerMap: Record<string, string> = {
	draft: "default",
	sent: "primary",
	accepted: "success",
	rejected: "danger",
	expired: "warning",
	cancelled: "muted",
	converted_to_order: "success",
};

const activityMap: Record<string, string> = {
	call: "primary",
	meeting: "success",
	email: "warning",
	note: "default",
	task: "primary",
	whatsapp: "success",
};

const orderMap: Record<string, string> = {
	draft: "default",
	confirmed: "primary",
	partially_delivered: "warning",
	delivered: "success",
	invoiced: "primary",
	closed: "muted",
	cancelled: "danger",
};

const contractMap: Record<string, string> = {
	draft: "default",
	active: "success",
	expired: "warning",
	terminated: "danger",
	renewed: "primary",
};

const stockItemMap: Record<string, string> = {
	active: "success",
	inactive: "muted",
};

export function StatusBadge({ status, type = "generic" }: StatusBadgeProps) {
	const { t } = useTranslation();
	let variant = "default";
	switch (type) {
		case "lead":
			variant = leadMap[status] ?? "default";
			break;
		case "opportunity":
			variant = oppMap[status] ?? "default";
			break;
		case "offer":
			variant = offerMap[status] ?? "default";
			break;
		case "activity":
			variant = activityMap[status] ?? "default";
			break;
		case "order":
			variant = orderMap[status] ?? "default";
			break;
		case "contract":
			variant = contractMap[status] ?? "default";
			break;
		case "stockItem":
			variant = stockItemMap[status] ?? "default";
			break;
	}
	return <Badge variant={variant as never}>{t(status)}</Badge>;
}
